<template>
  <Body class="hero is-bold">
    <div class="hero-body" :class="{'load-back': user==={}||isCBLoading||isApplyListLoading}" style="padding:0 !important;">
      <DashBoardMainMenu/>
      <!-- <transition name="slide"> -->
      <router-view v-if="user!={}&&!isCBLoading&&!isApplyListLoading"></router-view>
      <!-- </transition> -->
      <Loading v-if="user==={}||isCBLoading||isApplyListLoading"/>
    </div>
  </Body>
</template>

<script>
import { mapState } from 'vuex'
import Body from '@/components/layouts/Body'
import Loading from '@/components/animations/Loading'
import DashBoardMainMenu from '@/views/DashBoard/DashBoardMainMenu'
export default {
  name: 'DashBoardBody',
  componentName: 'DashBoardBody',
  components: {
    Body,
    DashBoardMainMenu,
    Loading
  },
  computed: {
    ...mapState('auth', ['user', 'slack', 'cw']),
    ...mapState('chatbot', ['chatbots', 'isCBLoading']),
    ...mapState('directtalk', ['isApplyListLoading'])
  }
}
</script>

<style scoped>
.load-back {
  background-color: #f2f2f2;
}
/* animation */
.slide-enter-active, .slide-leave-active {
  transition: all 0.2s;
  position: absolute;
  left: 80px;
}
.slide-enter {
  opacity: 1;
  transform: translateX(100%);
}
.slide-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DashBoardBody.vue